<template>
	<div class="intellectual-header">
		<section data-aos="fade-right" @click="$router.push('/')">
			<h1>知识产权服务平台</h1>
		</section>
		<section data-aos="fade-left">
			<div class="intellectual-header.search" v-show="showSearch">

				<div class="intellectual-header.pan">
					<span @click="togglePan">搜{{panValue}}</span>
					<transition name="slide-fade">
						<ul v-show="isShow">
							<li v-for="(pan,index) in panLists" :key="index" @click="choosePan(pan.name)">{{pan.name}}</li>
						</ul>
					</transition>

				</div>
				<div class="intellectual-header.input">
					<input type="text" :placeholder="'输入你想买的' + panValue +'名称'" v-model="searchAllVal">
				</div>
				<div class="intellectual-header.button" @click="searchAll">立即搜索</div>
			</div>
			<div class="intellectual-header.login">
				<!-- <a href="">登陆</a> -->
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		props: {
			showSearch: {
				default: false
			},
		},
		data() {
			return {
				panValue: '商标',
				panLists: [{
					name: '商标'
				}, {
					name: '专利'
				}, {
					name: '版权'
				}],
				selectValue: '',
				isShow: false,
				searchAllVal: ''
			}
		},
		methods: {
			togglePan() {
				this.isShow = !this.isShow
			},
			choosePan(value) {
				this.panValue = value
				this.isShow = false
			},
			searchAll() {
				this.$emit('showConsultationEvent',true)
				// if (this.panValue == '商标') {
				// 	this.$router.push({
				// 		path: 'Trademark',
				// 		query: {
				// 			name: this.searchAllVal
				// 		}
				// 	})
				// } else if (this.panValue == '专利') {
				// 	this.$router.push({
				// 		path: 'Patent',
				// 		query: {
				// 			name: this.searchAllVal
				// 		}
				// 	})
				// } else {
				// 	this.$router.push({
				// 		path: 'Copyright',
				// 		query: {
				// 			name: this.searchAllVal
				// 		}
				// 	})
				// }
			}
		}
	}
</script>

<style lang="scss">
	@include component(intellectual-header) {
		width: 1200px;
		position: relative;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #333;
		z-index: 999;
		padding-top: 48px;
		padding-bottom: 59px;
		font-size: 16px;

		>section {
			height: 100%;

			&:nth-child(1) {
				width: 418px;

				h1 {
					margin: 0;
					font-size: 35px;
					font-weight: 400;
					width: 100%;
					text-align: left;
					cursor: pointer;
					&:hover{
						color: #2278FC;
					}
				}
			}

			&:nth-child(2) {
				width: calc(100% - 418px);
				display: flex;
				align-items: center;
				justify-content: flex-end;
			}
		}

		@include part(search) {
			width: 650px;
			height: 46px;
			border: 1px solid rgba(244, 114, 39, 1);
			border-radius: 3px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-right:10px;

			@include component(el-input-group) {
				height: 100%;
				line-height: 46px;
				border: 1px solid rgba(244, 114, 39, 1);

			}

			@include component(el-input__inner) {
				height: 100%;
				border: none;
			}

			@include component(el-input-group__prepend) {
				width: 89px;
				background: none;
				color: #666666;
				border: none;

			}

			@include component(el-input-group__append) {
				background: rgba(255, 120, 62, 1);
				color: #fff;
				border: none;
				border-radius: 0;
			}


		}

		@include part(pan) {
			width: 89px;
			height: 46px;
			line-height: 46px;
			position: relative;
			cursor: pointer;
            >span {
				color: #666;
				display: inline-block;
				&:before {
					content: '';
					display: inline-block;
					width: 11px;
					height: 6px;
					position: absolute;
					right: 5px;
					top: 18.5px;
					background: url(../assets/down-nav.png);
					background-size: cover;
				}
			}

			ul {

				position: absolute;
				top: 45px;
				width: 100%;
				background: rgba(244, 114, 39, 1);
				color: #fff;


			}
		}

		@include part(input) {
			width: calc(100% - 229px);
			height: 40px;

			input {
				width: 100%;
				height: 100%;
				border: none;
				padding-left: 15px;
				outline: none;
				background: none;
			}
		}

		@include part(button) {
			width: 140px;
			height: 46px;
			line-height: 46px;
			background: rgba(244, 114, 39, 1);
			color: #FFFFFF;
			font-size: 16px;
			text-align: center;
			cursor: pointer;
		}

		@include part(login) {
			width: calc(100% - 673px);
			

			a {
				display: inline-block;
				text-decoration: none;
				width: 110px;
				height: 46px;
				line-height: 46px;
				background: rgba(255, 120, 62, 1);
				border: 1px solid rgba(255, 120, 62, 1);
				border-radius: 3px;
				color: #fff;
				position: relative;
				text-align: center;
				font-size: 18px;
				padding-left: 25px;

				&:before {
					content: '';
					display: inline-block;
					width: 22px;
					height: 22px;
					background-image: url(../assets/logo-nav.png);
					position: absolute;
					top: 12px;
					left: 20px;
				}
			}

		}
	}
</style>
